/**
 * @file index.ts
 * @description Индексный файл каталогов системы управления задачами.
 * Экспортирует конфигурации всех типов сущностей каталога: баги, требования, проекты,
 * сервисы, спринты, задачи, тест-кейсы и тест-планы.
 * Определяет единый интерфейс IEntityData для всех типов сущностей с полями
 * для модального окна поиска, форм, колонок таблицы и вкладок.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies [@src/types]
 * @related-files [./bug.tsx, ./functional-requirement.tsx, ./project.tsx, ./service.tsx, ./sprint.tsx, ./task.tsx, ./test-case.tsx, ./test-plan.tsx]
 */

import { ICatalogPage } from '@src/types/page';
import * as bug from './bug';
import * as functionalRequirement from './functional-requirement';
import * as project from './project';
import * as service from './service';
import * as sprint from './sprint';
import * as task from './task';
import * as testCase from './test-case';
import * as testPlan from './test-plan';

const items: ICatalogPage[] = [bug, functionalRequirement, project, service, sprint, task, testCase, testPlan];

export default items;
